declare var $: any;
declare var grecaptcha;

type Collection = { [field: string]: { [reason: string]: (string) => boolean } }
type SerializedForm = [{ name: string, value: any }]

export class validator {

    $form
    $variables = {} as { [key: string]: { valid: boolean, input: any, msg: any, required: boolean } }

    private tests = {
        LONGER_THAN_THREE_CHARACTERS: v => /.{3,}/.test(v),
        REQUIRED: v => /.+/.test(v),
        LIKE_EMAIL: v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v)
    }

	collection: Collection = {
		//Remove per Ric
        //"txtEmail": {
	        //"Needs to be longer than 3 characters.": this.tests.LONGER_THAN_THREE_CHARACTERS, 
            //"Email should be like email@google.com": this.tests.LIKE_EMAIL
        //},
        "txtPassword": {
            "Needs to be longer than 3 characters.": this.tests.LONGER_THAN_THREE_CHARACTERS,
        },
        "txtZipCode": {
            "Zip code must be 5 digits": v => /\d{5}/.test(v)
        },
        "hfRecaptcha": {
            "Prove you are not a ROBOT": v => grecaptcha.getResponse() != ""
        },
    }

    constructor(formId: string) {
        setTimeout(() => {
            this.$form = $(formId)
            const form = this.$form.serializeArray();
            this.$form.find('[type="checkbox"]').each((i, elm) => {
                form.push({ name: elm.name, value: $(elm).is(':checked') })
            });
            form.forEach(({ name }) => {
                const field = {
                    valid: null,
                    input: $(`[name="${name}"]`, formId),
                    msg: $(`[data-validation-for="${name}"]`, formId),
                    required: $(`[name="${name}"]`).is('[data-required]', formId)
                }
                if (field.required) {
                    this.collection[name] = this.collection[name] ? this.collection[name] : {}
                    var label = $(`label[for="${name}"]`, formId);
                    const text = label.data('friendly') || label.text() || field.input.attr('placeholder') || name
                    this.collection[name][`${text} is required.`] = this.tests.REQUIRED
                }
                this.$variables[name] = field
    
                field.input.on('focus', e => {
                    field.msg.addClass("focused")
                })
                field.input.on('focusout', e => {
                    field.msg.removeClass("focused")
                })
    
                field.input.on('keyup', e => {
                    this.test(name, e.target.value, field.required)
                })
                field.input.on('change', e => {
                    this.test(name, e.target.value, field.required, e.target.type == 'checkbox')
                })
            })
        }, 0);
    }

    get isValid() {
        for (const key in this.$variables) {
            if (this.$variables[key].valid === false) {
                return false
            }
        }
        return true
    }

    test(field: string, value: string, required: boolean, isCheckable?: boolean) {
        const variable = this.$variables[field]
        const collection = this.collection[field]
        variable.valid = true
        let reason = ""

        if (isCheckable && required && !$(variable.input).is(':checked')) {
            console.log(variable.input)
            variable.valid = false;
            reason = "This field is required"
        }

        for (const test in collection) {
            if (required || value) {
                if (collection[test](value) === false) {
                    variable.valid = false
                    reason = test
                    break
                }
            }
        }

        if (variable.valid && variable.input.is('.invalid')) {
            if (!variable.required && value === '') {
                variable.input.removeClass('invalid')
                variable.msg.text('')
            } else {
                variable.input.removeClass('invalid')
                variable.input.addClass('valid')
                variable.msg.text('')
            }
        } else if (!variable.valid) {
            variable.input.removeClass('valid')
            variable.input.addClass('invalid')
            variable.msg.text(reason)
        }
    }

    testAll() {
        for (const key in this.$variables) {
            const variable = this.$variables[key]
            this.test(key, variable.input.val(), variable.required, variable.input[0].type == 'checkbox')
        }
    }
}

mc = mc || {};
mc.validator = validator;